import React from 'react';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Loader2, AlertTriangle } from 'lucide-react';

export function DeleteAccountDialog({ open, onClose, onDelete, deletingAccount, submitting }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle size={18} className="text-red-500" />
            Delete Account
          </DialogTitle>
          <DialogDescription>
            Permanently delete <strong>{deletingAccount?.brand_name}</strong> and all associated data
            (users, locations, staff)? This cannot be undone.
            {deletingAccount?.stripe_subscription_id && ' Any active Stripe subscription will also be cancelled.'}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button
            variant="destructive"
            onClick={onDelete}
            disabled={submitting}
            data-testid="confirm-delete-account-btn"
          >
            {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Delete Account'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
